<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Assign Dasher To Team</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Assign New</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-select
                    v-model="editedItem.team_code"
                    :items="indexData.teams"
                    item-text="team_name"
                    item-value="team_code"
                    :rules="[ (v) => !!v || 'This field is required!',]"
                    box
                    label="Select Team"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-textarea
                    v-model="editedItem.user_mobile"
                    label="Dasher Mobile No"
                    @keyup="countMobileNumber()"
                    @keydown="countMobileNumber()"
                    :rules="[ (v) => !!v || 'This field is required!',]"
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if="checkLimit()<numberOfMobile">
                <v-flex xs12 sm12 md12 class="red--text">
                  You can assign maximum {{ checkLimit() }} dasher to this team
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" :disabled="checkLimit()<numberOfMobile" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.teamCodeResponse"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.team_code.team_name }}</td>
        <td class="text-xs-center">{{ props.item.team_code.team_code }}</td>
        <td class="text-xs-center">{{ props.item.VerificationStatus }}</td>
        <td class="text-xs-center">{{ props.item.DasherAgreement }}</td>
        <td class="text-xs-center">{{ props.item.ActiveStatus }}</td>
        <td class="text-xs-center">{{ props.item.dasher.first_name }} {{ props.item.dasher.last_name }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(props.item)"> delete </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import router from "@/router";
import utilities from "../../../api/utilities.js";

export default {
  data: () => ({
    dialog: false,
    search: "",
    numberOfMobile:null,
    apiUrl: "team-response",
    headers: [
      { text: "Team Name", align: "center", value: "team_name" },
      { text: "Team Code", align: "center", value: "team_code" },
      {
        text: "Verification Status",
        align: "center",
        value: "VerificationStatus",
      },
      { text: "Dasher Agreement", align: "center", value: "DasherAgreement" },
      { text: "Active Status", align: "center", value: "ActiveStatus" },
      {
        text: "Dasher Name",
        align: "center",
        sortable: false,
        value: "dasher_id",
      },
      { text: "Actions", align: "center", value: "actions" },
    ],
    editedIndex: -1,
    editedItem: {
      team_code: "",
      user_mobile: "",
    },
    defaultItem: {
      team_code: "",
      user_mobile: "",
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "subscriptionData",
      "errorMsg",
      "userImage",
      "docImage",
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? "New Dasher Assignment"
        : "Edit Dasher Assignment";
    },
    activeStatus(status) {
      if (status == "1") {
        return "Active";
      } else return "In-active";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    editItem(item) {
      this.editedIndex = this.indexData.teamCodeResponse.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    countMobileNumber() {
     this.numberOfMobile=this.editedItem.user_mobile.split(",").length
    },
    checkLimit(){
     return utilities.maximumNumberOfTeamMembers(this.subscriptionData.subscriptionFeatures)
    },

    deleteItem(item) {
      const index = this.indexData.teamCodeResponse.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.indexData.teamCodeResponse.splice(index, 1);
      this.$store.dispatch("delete", [this.apiUrl, item.id]);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      // console.log([this.editedItem]);
      if (this.editedIndex > -1) {
        this.$store.dispatch("storeOrUpdate", [this.apiUrl, this.editedItem]);
        this.$forceUpdate();
      } else {
        this.$store.dispatch("storeOrUpdate", [this.apiUrl, this.editedItem]);
        this.$forceUpdate();
      }
      this.close();
    },
  },
};
</script>
